import { useTranslation } from 'next-i18next';
import type { FC } from 'react';

import StatusMessageBox from 'components/StatusMessageBox';

const AddUserSuccess: FC = () => {
  const { t } = useTranslation();

  return (
    <StatusMessageBox
      type="success"
      message={t('common:pages.organization_overview.add_user.success')}
      description={t(
        'common:pages.organization_overview.add_user.success_info',
      )}
    />
  );
};

export default AddUserSuccess;
